var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-link-v2',{class:[_vm.name, `${_vm.name}__link`, { over: _vm.active }],attrs:{"url":_vm.href}},[_c('grid',{class:[`${_vm.name}__grid`],attrs:{"layout":[
      {
        size: 1,
        columns: 'repeat(12, 1fr)',
        gap: '6px',
      },
      {
        size: 2,
        columns: 'repeat(24, 1fr)',
        gap: '10px',
      },
    ]}},[_c('grid-item',{class:[`${_vm.name}__grid-item`],attrs:{"layout":[
        { size: 1, x: 1, width: 12 },
        { size: 3, x: 1, width: 24 },
      ]}},[_c('transition',{attrs:{"name":"fade"}},[((_vm.cms.image || {}).filename)?_c('a-image-v2',{class:`${_vm.name}__image img_transition`,attrs:{"src":_vm.cms.image.filename,"alt":_vm.cms.image.alt,"layout":_vm.layout}}):_vm._e()],1),_vm._v(" "),_c('div',{class:`${_vm.name}__content`},[(_vm.cms.heading)?_c('a-heading',{class:`${_vm.name}__heading`,attrs:{"html-tag":"h2","cms":_vm.cms}}):_vm._e(),_vm._v(" "),(_vm.cms.eyebrow)?_c('a-eyebrow',{class:`${_vm.name}__eyebrow`,attrs:{"cms":_vm.cms}}):_vm._e(),_vm._v(" "),(_vm.cms.copy)?_c('div',{class:`${_vm.name}__text`,domProps:{"innerHTML":_vm._s(_vm.$options.filters.markdown(_vm.cms.copy))}}):_vm._e(),_vm._v(" "),(_vm.cms.tags)?_c('div',{class:`${_vm.name}__tags`},_vm._l((_vm.cms.tags.split(',')),function(pill,index){return _c('div',{key:index},[_vm._v("\n            "+_vm._s(pill)+"\n          ")])}),0):_vm._e(),_vm._v(" "),_vm._l((_vm.cms.cta),function(item){return _c(item.component,{directives:[{name:"editable",rawName:"v-editable",value:(item),expression:"item"}],key:item._uid,tag:"component",class:`${_vm.name}__cta`,attrs:{"cms":{
            ...item,
            href: { url: _vm.href },
          }}})})],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }